module.exports = __webpack_public_path__ + "img/base-active-skill-star.de54ae62.svg";